module.exports = __webpack_public_path__ + "img/about-img.180bda68.png";